/* tslint:disable */
/* eslint-disable */
/* @relayHash 439e7e81ea1a13110b5b7e8e1a25d98d */

import { ConcreteRequest } from "relay-runtime";
export type Currency = "AUD" | "CAD" | "CHF" | "EUR" | "GBP" | "JPY" | "MXN" | "USD" | "%future added value";
export type DesignProfileStatus = "ACTIVE" | "DELETED" | "NEW" | "PENDING" | "%future added value";
export type initializeTrackingQueryVariables = {
    hasUserId: boolean;
    userId: string;
    checkoutUserId: string;
    hasCheckoutUserId: boolean;
};
export type initializeTrackingQueryResponse = {
    readonly viewer: {
        readonly transactionsCounter?: {
            readonly submittedTransactions?: number | null;
            readonly confirmedTransactions?: number | null;
            readonly guestCheckoutTransactions: number | null;
        } | null;
        readonly user?: {
            readonly createdDate: string | null;
            readonly firstSessionDate: string | null;
            readonly isVip: boolean | null;
            readonly isVerifiedTrade: boolean | null;
            readonly verifiedTradeStatus: string | null;
            readonly authMetadata: {
                readonly emailOnly: boolean | null;
                readonly hasPassword: boolean | null;
            } | null;
            readonly profile: {
                readonly email: string | null;
                readonly zipCode: string | null;
                readonly currency: Currency | null;
            } | null;
            readonly serviceId: string | null;
            readonly totalMessagesToDealers: number | null;
            readonly tradeFirm: {
                readonly serviceId: string | null;
                readonly profileStatus: DesignProfileStatus | null;
                readonly rewards: {
                    readonly currentProgram: {
                        readonly programInfo: {
                            readonly code: string | null;
                        } | null;
                    } | null;
                } | null;
            } | null;
            readonly mentionMeTagParameters: {
                readonly ciphertext: string | null;
                readonly nonce: string | null;
            } | null;
            readonly activePromotion: {
                readonly campaignName: string | null;
                readonly buyerDisplayable: boolean | null;
            } | null;
        } | null;
    };
};
export type initializeTrackingQuery = {
    readonly response: initializeTrackingQueryResponse;
    readonly variables: initializeTrackingQueryVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "hasUserId",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "userId",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "checkoutUserId",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "hasCheckoutUserId",
    "type": "Boolean!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "Condition",
  "passingValue": true,
  "condition": "hasCheckoutUserId",
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "transactionsCounter",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "buyerId",
          "variableName": "checkoutUserId"
        }
      ],
      "concreteType": "TransactionsCounter",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": "guestCheckoutTransactions",
          "name": "guest",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "Condition",
          "passingValue": true,
          "condition": "hasUserId",
          "selections": [
            {
              "kind": "ScalarField",
              "alias": "submittedTransactions",
              "name": "submitted",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": "confirmedTransactions",
              "name": "confirmed",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
},
v2 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId"
  }
],
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "createdDate",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "firstSessionDate",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isVip",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isVerifiedTrade",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "verifiedTradeStatus",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "emailOnly",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "hasPassword",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "profile",
  "storageKey": null,
  "args": null,
  "concreteType": "Profile",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "email",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "zipCode",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "currency",
      "args": null,
      "storageKey": null
    }
  ]
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "totalMessagesToDealers",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "profileStatus",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "code",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "mentionMeTagParameters",
  "storageKey": null,
  "args": null,
  "concreteType": "mentionMeTagParameters",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "ciphertext",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "nonce",
      "args": null,
      "storageKey": null
    }
  ]
},
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "campaignName",
  "args": null,
  "storageKey": null
},
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "buyerDisplayable",
  "args": null,
  "storageKey": null
},
v18 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "initializeTrackingQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "hasUserId",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "user",
                "storageKey": null,
                "args": (v2/*: any*/),
                "concreteType": "User",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "authMetadata",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserExistsMetadataType",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      (v9/*: any*/)
                    ]
                  },
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "tradeFirm",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "TradeFirmType",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/),
                      (v13/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "rewards",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "TradeFirmRewards",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "currentProgram",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ParentProgram",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "programInfo",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "LoyaltyProgram",
                                "plural": false,
                                "selections": [
                                  (v14/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  (v15/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "activePromotion",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Promotion",
                    "plural": false,
                    "selections": [
                      (v16/*: any*/),
                      (v17/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "initializeTrackingQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          (v18/*: any*/),
          (v1/*: any*/),
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "hasUserId",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "user",
                "storageKey": null,
                "args": (v2/*: any*/),
                "concreteType": "User",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "authMetadata",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "UserExistsMetadataType",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v18/*: any*/)
                    ]
                  },
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "tradeFirm",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "TradeFirmType",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/),
                      (v13/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "rewards",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "TradeFirmRewards",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "currentProgram",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ParentProgram",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "programInfo",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "LoyaltyProgram",
                                "plural": false,
                                "selections": [
                                  (v14/*: any*/),
                                  (v18/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v18/*: any*/)
                    ]
                  },
                  (v15/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "activePromotion",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Promotion",
                    "plural": false,
                    "selections": [
                      (v16/*: any*/),
                      (v17/*: any*/),
                      (v18/*: any*/)
                    ]
                  },
                  (v18/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "initializeTrackingQuery",
    "id": "ferrum/292.0.0-2020-11-18T17:30:45.474Z/initializeTrackingQuery",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = 'b191054340b5b95f945e64b39baf933a';
export default node;
